<template lang="pug">
.order-main
	h2 Review order

	p
		| Please review your order carefully.  &nbspUse the steps links below if
		| you need to change the information that you provided on a prior page.
		| &nbspClick below on 'Place your Order' to finalize your order.

	h3 Project: # {{ project.projId }} - {{ project.name }}

	.cart
		h2(v-show='!products.length') Your cart is empty!

		invoice-detail(:products="products",
						:subtotal="subtotal",
						:taxAmount="taxAmount",
						:total="total")

		h2 Payment Information

		credit-card(:card="card")

		contacts-block(:contacts="contacts")

		.div-container-right
			span
			a(v-show='products.length', @click='checkout')
				easyBtn(btnText="Checkout")
			//- input.btn-def(type="submit", value="Checkout", v-show='products.length', @click='checkout')

	form(ref="paymentForm", :action="payFormAction", method="post", target="_self", )
		input(type="hidden", v-for="field in payFormFields", :name="field.name", v-model="field.value")

</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import Promise from 'bluebird'
import Contact from 'Common/components/party/person.vue'
import easyBtn from 'Common/components/easy-btn.vue'
import store from 'CommonApp/store'
import { calcOrderTotals } from 'CommonApp/e24-services/order-totals-util'

export default {
	name: 'checkout-order',
	props: ['card', 'contacts', 'project', 'order'],
	components: { Contact, easyBtn },
	data () {
		return {
			payFormAction: '',
			payFormFields: [],
			config: {},
			validContacts: {
				DM: {
					result: true
				},
				SG: {
					result: true
				}
			}
		}
	},
	computed: {
		...mapGetters({
			products: 'cartProducts'
		}),
		// ...mapState({
		// 	config: state => state.config
		// }),
		rawSubtotal () {
			return this.products.reduce((subtotal, p) => {
				return subtotal + p.price * p.quantity
			}, 0)
		},
		orderTotals () {
			// const ta = this.rawSubtotal * this.config.tax.CA.rate -- CA tax not yet implemented, hardcoded to 0
			return calcOrderTotals(this.rawSubtotal, 0)
		},
		subtotal () {
			return this.orderTotals.subtotal
		},
		taxAmount () {
			return this.orderTotals.taxAmount
		},
		total () {
			return this.orderTotals.total
		}
	},
	created () {
		this.config = process.env.CHECKOUT
	},
	methods: {
		checkout () {
			let contactOps = []

			// Process contacts
			this.contacts.forEach(contact => {
				if (_.isNil(contact.object.contactId)) {
					// Insert contact
					contactOps.push(Vue.e24.contactService.insert(contact.object))
				} else {
					// Update contact
					contactOps.push(Vue.e24.contactService.update(contact.object))
				}
			})

			Promise.all(contactOps).then(contactOpsRes => {
				console.log('Insert/update contacts result', contactOpsRes)

				const contacts = _.flatten(contactOpsRes)
				const billingAddress = _.find(contacts, { typeId: 'BO' })
				const shippingAddress = _.find(contacts, function (contact) {
					return (
						contact.typeId === 'SO' ||
						contact.typeId === 'SG' ||
						contact.typeId === 'DM'
					)
				})

				let processOrder = null

				if (!_.isNil(this.order) && (_.isNil(this.order.payment) || _.isNil(this.order.payment.approvalCode))) {
					console.log('updating order')
					// Update totals and save existing order
					this.order.shipAddressId = _.isNil(shippingAddress)
						? null
						: shippingAddress.contactId
					this.order.shipMethodId = _.isNil(shippingAddress)
						? null
						: this.config.defaultShipMethod
					this.order.orderSubtotal = this.subtotal
					this.order.orderTax = this.taxAmount
					this.order.orderShippingTax = 0
					this.order.orderStatus = this.config.orderStatus.pending.code // Pending
					// Sending items as part of order object
					this.order.items = this.products

					console.log('Order found, just update values', this.order)
					processOrder = Vue.e24.orderService.update(this.order)
				} else {
					console.log('inserting order', this.config)
					// Insert as new order
					const newOrder = {
						userId: Vue.e24.security.currentUser.userId,
						projId: this.project.projId,
						billAddressId: billingAddress.contactId,
						shipAddressId: _.isNil(shippingAddress)
							? null
							: shippingAddress.contactId,
						shipMethodId: _.isNil(shippingAddress)
							? null
							: this.config.defaultShipMethod,
						orderSubtotal: this.subtotal,
						orderTax: this.taxAmount,
						orderShipping: 0,
						orderShippingTax: 0,
						orderStatus: this.config.orderStatus.unpaid.code, // Unpaid
						// Sending items as part of order object
						items: this.products,
						payment: {}
					}
					console.log(
						'order not found for this project, creating a new one',
						newOrder
					)
					processOrder = Vue.e24.orderService.insert(newOrder)
				}

				processOrder.then(orderStored => {
					console.log('Order stored', orderStored)
					store.dispatch({
						type: 'updateLastOrder',
						value: orderStored
					})

					// Process payment
					Vue.e24.paymentService
						.composePaymentObj(this.card, orderStored, this.contacts[0].object)
						.then(paymentObj => {
							// Load fields
							this.payFormAction = paymentObj.action
							this.payFormFields = paymentObj.data

							setTimeout(() => {
							// Submit
								this.$refs.paymentForm.submit()
							}, 100)

							console.log('Payment object', paymentObj)
						})
				})
			})
		}
	}
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/app/checkout/tabs-components/order.vue